module.exports = "<app-header></app-header>\r\n\r\n<app-sliders></app-sliders>\r\n\r\n<app-feature-style1></app-feature-style1>\r\n\r\n<app-service-style1></app-service-style1>\r\n\r\n<app-customer-style1></app-customer-style1>\r\n\r\n<!-- <app-applink-style1></app-applink-style1> -->\r\n<!-- <app-callout-style1></app-callout-style1> -->\r\n\r\n<app-footer></app-footer>"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/home.component.html
// module id = ./src/app/home/home.component.html
// module chunks = main